import { Component, inject, output, ChangeDetectionStrategy } from '@angular/core';
import { IonAccordion, IonButton, IonItem, IonLabel } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyResultComponent, SkeletonCardInprogressComponent } from '@okcargo-apps/layout-ionic';
import { FreightCarrierStoreService } from '../freight-carrier-store.service';
import { FreightCarrierFinishedCardComponent } from '../freight-carrier-finished-card/freight-carrier-finished-card.component';

@Component({
  selector: 'lib-freight-carrier-pending-docs-list',
  templateUrl: './freight-carrier-pending-docs-list.component.html',
  styleUrls: ['./freight-carrier-pending-docs-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonAccordion,
    IonButton,
    IonItem,
    IonLabel,
    FreightCarrierFinishedCardComponent,
    SkeletonCardInprogressComponent,
    TranslateModule,
    EmptyResultComponent,
  ],
})
export class FreightCarrierPendingDocsListComponent {
  private readonly freightCarrierStoreService = inject(FreightCarrierStoreService);

  protected readonly vm = this.freightCarrierStoreService.freightsWithPendingDocumentation;

  // Emitted when there are more freights than the ones rendered; the hosting page
  // owns the navigation (e.g. to the finished tab filtered by this list).
  public readonly seeMore = output<void>();
}
